import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f34025bc")

_pushScopeId("data-v-f34025bc")
const _hoisted_1 = { class: "writing-board-tool" }
const _hoisted_2 = { class: "tools" }
const _hoisted_3 = { class: "colors" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_WritingBoard = _resolveComponent("WritingBoard")
  const _component_IconWrite = _resolveComponent("IconWrite")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_IconErase = _resolveComponent("IconErase")
  const _component_IconClear = _resolveComponent("IconClear")
  const _component_IconClose = _resolveComponent("IconClose")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_WritingBoard, {
        ref: "writingBoardRef",
        color: _ctx.writingBoardColor,
        model: _ctx.writingBoardModel
      }, null, 8, ["color", "model"])
    ])),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.3,
        title: "画笔"
      }, {
        default: _withId(() => [
          _createVNode("div", {
            class: ["btn", { 'active': _ctx.writingBoardModel === 'pen' }],
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePen()))
          }, [
            _createVNode(_component_IconWrite, { class: "icon" })
          ], 2)
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"]),
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.3,
        title: "橡皮擦"
      }, {
        default: _withId(() => [
          _createVNode("div", {
            class: ["btn", { 'active': _ctx.writingBoardModel === 'eraser' }],
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeEraser()))
          }, [
            _createVNode(_component_IconErase, { class: "icon" })
          ], 2)
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"]),
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.3,
        title: "清除墨迹"
      }, {
        default: _withId(() => [
          _createVNode("div", {
            class: "btn",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearCanvas()))
          }, [
            _createVNode(_component_IconClear, { class: "icon" })
          ])
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"]),
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.writingBoardColors, (color) => {
          return (_openBlock(), _createBlock("div", {
            class: ["color", { 'active': color === _ctx.writingBoardColor }],
            key: color,
            style: { backgroundColor: color },
            onClick: ($event: any) => (_ctx.changeColor(color))
          }, null, 14, ["onClick"]))
        }), 128))
      ]),
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.3,
        title: "关闭画笔"
      }, {
        default: _withId(() => [
          _createVNode("div", {
            class: "btn",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeWritingBoard()))
          }, [
            _createVNode(_component_IconClose, { class: "icon" })
          ])
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"])
    ])
  ]))
})